import React from 'react'
import PropTypes from 'prop-types'
import { filter } from 'lodash'
import { Box, Typography } from '@material-ui/core'

import { JoditEditor } from 'components'
import { ReviewItemList } from './components'

import helpers from 'helpers'

import theme from 'theme'

import constants from 'constants/index'
import useStyles from './styles'

// A resposta escolhida pelo revisor (nota de aderência) não vai para a organização: só o parecer e os itens.
const ReviewOpinionContent = ({ opinion }) => {
  const { REVIEW_OPINION_ITEM_SECTIONS } = constants.governanceProjectActivity
  const { RICH_TEXT_SANITIZE_PROFILE } = constants.jodit

  const classes = useStyles()

  return (
    <Box display="flex" flexDirection="column" gridGap={theme.spacing(3)}>
      <Box>
        <Typography variant="h6" color="textSecondary" gutterBottom>
          Parecer
        </Typography>
        <Box className={classes.opinionBox}>
          <JoditEditor.Preview
            sanitizeProfile={RICH_TEXT_SANITIZE_PROFILE}
            content={helpers.governanceProject.formatOpinionHtml(opinion?.text)}
          />
        </Box>
      </Box>
      {REVIEW_OPINION_ITEM_SECTIONS.map(({ kind, title }) => (
        <ReviewItemList
          key={kind}
          title={title}
          items={filter(opinion?.opinionItems, { kind })}
        />
      ))}
    </Box>
  )
}

ReviewOpinionContent.propTypes = {
  opinion: PropTypes.shape({
    text: PropTypes.string,
    opinionItems: PropTypes.arrayOf(
      PropTypes.shape({
        kind: PropTypes.string,
        position: PropTypes.number,
        description: PropTypes.string,
      }),
    ),
  }),
}

export default ReviewOpinionContent
